import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  pinnedMsgs: localStorage.getItem('pinnedmsgs') && JSON.parse(localStorage.getItem('pinnedmsgs'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/pinned/index.js